import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["grid"]
  static values = { propertyId: Number }

  connect() {
    this.initializeSortable()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  initializeSortable() {
    this.gridTargets.forEach((grid) => {
      this.sortable = Sortable.create(grid, {
        handle: '.drag-handle',
        animation: 150,
        ghostClass: 'photo-ghost',
        chosenClass: 'photo-chosen',
        dragClass: 'photo-drag',
        filter: '.add-photos-card',
        onEnd: (evt) => {
          this.updatePhotoOrder(grid)
        }
      })
    })
  }

  updatePhotoOrder(grid) {
    const photoItems = grid.querySelectorAll('.photo-item')
    const orderedIds = Array.from(photoItems).map(item => 
      parseInt(item.dataset.photoId)
    ).filter(id => !isNaN(id))

    if (orderedIds.length === 0) return

    // Send AJAX request to update positions
    fetch(`/properties/${this.propertyIdValue}/reorder_property_photos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ ordered_ids: orderedIds })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to reorder photos')
      }
    })
    .catch(error => {
      console.error('Error reordering photos:', error)
      // Could add user-facing error message here
    })
  }
}